import React from "react";

import styled from "styled-components";

import { Box, BoxProps, Text } from "@origin-digital/ods-core";
import { INavItemProps } from "../types";
import CountBadge from "../CountBadge";
import { useNavItem } from "./useNavItem";

interface IHoverBoxProps extends BoxProps {
  selected: boolean;
}

const HoverBox = styled(Box)<IHoverBoxProps>`
  &:hover {
    background-color: #f1f1f1;
    cursor: pointer;
  }

  ${(props) =>
    props.selected &&
    `
    border-bottom: 4px solid ${props.theme.colors.primary};
  `}
`;

const NavItem = (props: INavItemProps) => {
  const { title, count, selected, handleClick } = useNavItem(props);

  return (
    <HoverBox
      data-id={selected ? "selected-tab" : undefined}
      selected={selected}
      paddingX="large"
      paddingY="medium"
      height="full"
      onClick={handleClick}
    >
      {" "}
      <Box
        component="nav"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Text
          weight={selected ? "medium" : "regular"}
          tone={selected ? "neutralDark" : "neutral"}
        >
          {title}
        </Text>
        {count && count !== 0 ? <CountBadge count={count} /> : null}
      </Box>
    </HoverBox>
  );
};

export default NavItem;
